//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WorkTasksDrawer from "./modules/WorkTasksDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryIdTree, queryUserTreeList } from '@api/api';
export default {
  name: "WorkTasksList",
  mixins: [JeecgListMixin],
  components: {
    WorkTasksDrawer: WorkTasksDrawer
  },
  data: function data() {
    return {
      pagePath: '/work/tasks',
      pageTitle: '计划列表',
      workTasksHandle: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'title',
        colName: 'plan_matters',
        title: '计划事项',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'userId',
        colName: 'user_id',
        title: '牵头责任人',
        align: "center",
        sorter: true,
        customRender: function customRender(t, r, index) {
          return r.userId_userName;
        }
      }, {
        dataIndex: 'departId',
        colName: 'depart_id',
        title: '责任科室',
        align: "center",
        sorter: true,
        customRender: function customRender(t, r, index) {
          return r.departName;
        }
      }, {
        dataIndex: 'startTime',
        colName: 'start_time',
        title: '开始时间',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'endTime',
        colName: 'end_time',
        title: '截止时间',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'relatedRequirements',
        colName: 'relatedRequirements',
        title: '相关要求',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '状态',
        align: "center",
        sorter: true,
        customRender: function customRender(t, r, index) {
          return r.status_dictText;
        }
      }, // {
      //   dataIndex: 'remark',
      //   colName: 'remark',
      //   title: '备注',
      //   align: "center",
      //   sorter: true
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadDepartTree();
    this.loadTreeList();
  },
  computed: {},
  methods: {
    handleEdit: function handleEdit(record, handle) {
      this.workTasksHandle = handle;
      this.$refs.modalForm.edit(record); //console.log(record)

      if (handle) {
        this.$refs.modalForm.title = '办理：' + this.pageTitle;
        this.$refs.modalForm.disableSubmit = true;
      } else {
        this.$refs.modalForm.title = '编辑：' + this.pageTitle;
        this.$refs.modalForm.disableSubmit = false;
      }

      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    loadDepartTree: function loadDepartTree() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          that.departTreeData = res.result;
        }
      });
    },
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    onDateStartTime: function onDateStartTime(value, dateArray) {
      this.queryParam.startTimeStart = "".concat(dateArray[0], " 00:00:00");
      this.queryParam.startTimeEnd = "".concat(dateArray[1], " 23:59:59");
    },
    onDateEndTime: function onDateEndTime(value, dateArray) {
      this.queryParam.endTimeStart = "".concat(dateArray[0], " 00:00:00");
      this.queryParam.endTimeEnd = "".concat(dateArray[1], " 23:59:59");
    }
  }
};